import { Steps } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { bailiffDocumentStepSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const UploadStepper = () => {
  // -------------------------- VAR -----------------------------
  const items = [
    {
      title: "Tải file audio/video",
    },
    {
      title: "Preview & Xác nhận File",
    },
    {
      title: "Hoàn tất tải file",
    },
  ];
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const step = useSelector(bailiffDocumentStepSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return <Steps current={step} items={items} />;
};
export default UploadStepper;
